// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__3gdqU","tabItem":"Content_tabItem__2hDyF","row":"Content_row__3YXBD","image":"Content_image__1kwq2"};